export const MASK_TYPES = {
    phone: '+7 (999) 999-99-99',
    tel: '+7 (999) 999-99-99',
};

export const FORMAT_CHARS = {
    9: '\\d',
    a: '/[a-z]/i',
    '*': '/[a-z\\d]/i',
};

export const PLACEHOLDER_MASK = '+7 (000) 000-00-00';
